import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ClioConstants } from "../../models/clio-constants/clio-constants";
import { BreakpointObserver } from "@angular/cdk/layout";
import { CardStatusService } from "../../services/card-status/card-status.service";
import { AuthService } from "../../services/auth/auth.service";
import { Store } from "@ngrx/store";
import { saveCardNumbers } from "../../stores/user-input/user-input.actions";
import { Observable, take } from "rxjs";
import { CardNumbersState } from "../../stores/card-numbers/card-numbers-state"
import { CardNumbersResponse } from "../../models/response/card-status/CardNumbersResponse";
import { UserRouteTrackingService } from "../../services/user-route-tracking/user-route-tracking.service";

@Component({
  selector: 'app-cardstatus',
  templateUrl: './cardstatus.component.html',
  styleUrls: ['./cardstatus.component.scss'],
  standalone: false
})
export class CardstatusComponent implements OnInit {

  cardNumbers$!: Observable<CardNumbersResponse>;
  areCardsLoaded$: Observable<boolean> | undefined;
  cardTypeMap = {
    bcdl: "BC Driver's Licence / Combo Card / Learner's Licence",
    bcid: "BC Identification Card",
    bcsc: "BC Service Card"
  };
  userCards: { viewValue: string; value: keyof CardNumbersResponse }[] = [];

  showError: boolean = false;
  success: boolean = false;
  successMessage: string = "";
  mobileView!: boolean;
  failedAttempt: number = 0;

  constructor(private fb: FormBuilder,
              private cardStatusService: CardStatusService,
              private router: Router,
              private observer: BreakpointObserver,
              private authService: AuthService,
              private userRouteTrackingService: UserRouteTrackingService,
              private store: Store<{
                cardNumbersReducer: CardNumbersState
              }>) {
    this.cardNumbers$ = this.store.select(state => state.cardNumbersReducer.data);
    this.areCardsLoaded$ = this.store.select(state => state.cardNumbersReducer.isLoaded);
  }

  ngOnInit(): void {
    this.userRouteTrackingService.setLastAtCardStatusPage();
    this.observer.observe(['(max-width:768px)']).subscribe((res) => {
      this.mobileView = !res.matches;
    })

    this.authService.startSessionPolling();
    this.authService.startSessionExpiryWatcher();

    this.cardStatusService.checkCardTypeEligibility().subscribe(
      response => {
        // console.log(response)
        if (Object.values(response).every(cardNumber => !cardNumber)) {
          this.router.navigate(['error/status-not-found'], {
            queryParams: {
              code: 'CS-01'
            }
          });
        }
        this.store.dispatch(saveCardNumbers({ response }));
      },
      error => {
        // console.error(error);
        this.router.navigate(['error/status-not-found'], {
          queryParams: {
            code: 'CS-02'
          }
        });
      }
    );

    this.cardNumbers$.subscribe(cardNumbers => {
      this.userCards = [];
      Object.entries(cardNumbers).forEach(([cardType, cardNumber]) => {
        if (cardNumber) {
          this.userCards.push({
            viewValue: (this.cardTypeMap)[cardType as keyof CardNumbersResponse],
            value: cardType as keyof CardNumbersResponse,
          });
        }
      });
    });
  }

  ngOnDestroy() {
    this.authService.stopSessionExpiryWatcher();
  }

  checkCardStatus(cardType: string) {
    this.showError = false;
    this.cardNumbers$.pipe(take(1)).subscribe(cardNumbers => {
      if (Object.values(cardNumbers).every(value => value === '')) {
        this.router.navigate(['error/status-not-found'], {
          queryParams: {
            code: 'CS-03'
          }
        });
      }
      const cardStatusRequest = {
        cardType: cardType
      };
      this.cardStatusService.checkCardStatus(cardStatusRequest).subscribe(
        response => {
          // console.log('CardstatusComponent: resposne from backend=' + JSON.stringify(response));
          if (response.status === 'OK') {
            this.success = true;
            this.successMessage = response.historyReturned;
          } else if (response.status === 'FAIL') {
            this.failedAttempt += 1;
            if (this.failedAttempt % ClioConstants.MAX_ATTEMPTS == 0)
              this.router.navigate(['statusexceededtries']);
            else
              this.showError = true;
          } else if (response.status === 'ERROR') {
            this.router.navigate(['error/status-not-found'], {
              queryParams: {
                code: 'CS-04'
              }
            });
          }
        },
        error => {
          // console.error(error);
          this.router.navigate(['error/status-not-found'], {
            queryParams: {
              code: 'CS-05'
            }
          });
        });
    });
  }


}
